/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseRegulationDto } from '../../models/response-regulation-dto';

export interface GetRegulations$Params {
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';

/**
 * The customer id
 */
  customerId: number;

/**
 * id of risk assessment, which groups regulations
 */
  riskAssessmentId: number;

/**
 * search string for field description of a regulation
 */
  description?: string;

/**
 * search string for specific regulation id
 */
  id?: number;

/**
 * search string for field label of a regulation
 */
  label?: string;
}

export function getRegulations(http: HttpClient, rootUrl: string, params: GetRegulations$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseRegulationDto>> {
  const rb = new RequestBuilder(rootUrl, getRegulations.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.path('customerId', params.customerId, {});
    rb.path('riskAssessmentId', params.riskAssessmentId, {});
    rb.query('description', params.description, {});
    rb.query('id', params.id, {});
    rb.query('label', params.label, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseRegulationDto>;
    })
  );
}

getRegulations.PATH = '/customers/{customerId}/risk-assessment/{riskAssessmentId}/regulations';
